import React from "react";
import Images from "../UserInterface/Images";
import Pegadaian from "../../../public/static/images/png/Pegadaian_logo.png";
import Fastpay from "../../../public/static/images/png/logo-fastpay.png";
import Indomart from "../../../public/static/images/svg/retail/indomart_ic.svg";
import Alfamart from "../../../public/static/images/svg/retail/alfamart_group.svg";
import PosIndonesia from "../../../public/static/images/svg/pos_indonesia_ic.svg";
const GeraiRetail = () => {
  return (
    <div className="gerai-retail-wrapper">
      <div className="gerai-retail-container">
        <div className="image-container">
          <Images
            margin="0px"
            width="140px"
            url={Indomart}
            mobileWidth="64px"
          ></Images>
          <Images
            margin="0px"
            width="140px"
            url={Alfamart}
            mobileWidth="70px"
          ></Images>
          <Images margin="0px" width="140px" url={PosIndonesia}></Images>
          <Images
            margin="0 10px 0 10px"
            width="70px"
            mobileWidth="40px"
            url={Pegadaian}
          ></Images>
          <Images
            margin="-5px 0px 0 0px"
            width="140px"
            mobileWidth="90px"
            url={Fastpay}
          ></Images>
        </div>
        <div>
          <p className="title">Pembayaran dapat dilakukan di:</p>
          <p>
            Indomaret, Alfamart, Alfamidi, Alfa Express, DanDan, Lawson,
            Ceriamart, Pos Indonesia, Pegadaian dan Fastpay
          </p>
          <ol>
            <li>
              Datangi <b>KASIR/PETUGAS</b>, informasikan pembayaran{" "}
              <b>HOME CREDIT</b>
            </li>
            <li>
              Informasikan <b>NOMOR KONTRAK</b> Kamu
            </li>
            <li>
              Ikuti petunjuk <b>KASIR/PETUGAS</b>
            </li>
            <li>
              Bayar jumlah pembayaran sesuai <b>TAGIHAN</b>
            </li>
            <li>
              Simpan <b>SLIP</b> sebagai bukti pembayaran
            </li>
          </ol>
        </div>
      </div>
      <style jsx>{`
        .gerai-retail-wrapper {
          display: flex;
          justify-content: center;
        }
        .gerai-retail-container {
          max-width: 780px;
          width: 100%;
          margin: 16px;
        }
        .image-container {
          display: flex;
        }
        .title {
          font-weight: bold;
          font-size: 20px;
        }
        li {
          margin: 18px 16px 18px 60px;
        }
        @media only screen and (max-width: 600px) {
          li {
            margin: 8px 16px;
            font-size: 14px;
          }
          .title {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default GeraiRetail;
